import { Helmet } from 'react-helmet-async';
// sections
import Login from '../../../sections/auth/client/Login';
// import Login from '../../sections/auth/LoginAuth0';

// ----------------------------------------------------------------------

export default function LoginPage() {
  return (
    <>
      <Helmet>
        <title> Accesso Cliente | App di Mediazione Telefonica</title>
      </Helmet>

      <Login />
    </>
  );
}
